import { computed, effect, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { CustomRouteService } from '../../../services/custom-route.service';
import { PlannerDayStateService } from './planner-day-state.service';

@Injectable({
  providedIn: 'root'
})
export class PlannerSelectedDayStateService {
  public selectedDate: WritableSignal<Date | undefined> = signal<Date | undefined>(undefined);
  
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  
  private readonly _dayToShowIndex = computed(() => this._plannerDayStateService.dayToShowIndex());
  private readonly _customRouteData = computed(() => this._customRouteService.customRouteData());
  
  setSelectedDate = effect(() => {
    if (!this._customRouteData()?.dailyRoutes || this._dayToShowIndex() < 0) return;
    
    const route = this._customRouteData().dailyRoutes?.[this._dayToShowIndex()];
    if (!route) return;

    this.selectedDate.set(new Date(route.date));
  }, { allowSignalWrites: true });
}
